<template>
  <div class="forgot-password-container">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card mt-5">
            <div class="card-header text-center">
              <h2>Forgot Your Password?</h2>
            </div>
            <div class="card-body">
              <div v-if="!emailSent">
                <p class="text-muted mb-4">
                  Enter your email address and we'll send you a code to reset your password.
                </p>
                
                <form @submit.prevent="sendResetEmail">
                  <div class="form-group">
                    <label for="email">Email Address *</label>
                    <input 
                      type="email" 
                      class="form-control" 
                      id="email" 
                      v-model="email"
                      placeholder="Enter your email address"
                      required
                    >
                  </div>
                  
                  <div class="form-group">
                    <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
                      {{ loading ? 'Sending...' : 'Send Reset Code' }}
                    </button>
                  </div>
                </form>
                
                <div class="text-center mt-3">
                  <router-link to="/login">Back to Login</router-link>
                </div>
              </div>
              
              <div v-else class="text-center">
                <h4>Please enter the verification code and your new password</h4>
                <form @submit.prevent="resetPassword" class="mt-4">
                  <div class="form-group">
                    <label for="email">Email</label>
                    <input type="email" class="form-control" id="email" v-model="email" readonly>
                  </div>
                  <div class="form-group">
                    <label for="captcha">Verification Code</label>
                    <input type="text" class="form-control" id="captcha" v-model="captcha" placeholder="Enter the code you received" required>
                  </div>
                  <div class="form-group">
                    <label for="newPassword">New Password</label>
                    <input type="password" class="form-control" id="newPassword" v-model="newPassword" placeholder="Enter your new password" required>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block" :disabled="resetLoading">
                    {{ resetLoading ? 'Resetting...' : 'Reset Password' }}
                  </button>
                </form>
                <div class="mt-3">
                  <router-link to="/login">Back to Login</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from '@/config/api'
export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      emailSent: false,
      loading: false,
      resendLoading: false,
      captcha: '',
      newPassword: '',
      resetLoading: false
    }
  },
  methods: {
    async sendResetEmail() {
      this.loading = true
      try {
        await apiService.auth.forgotPassword({
          email: this.email,
          scene: 'resetpwd'
        })
        this.emailSent = true
      } catch (error) {
        console.error('Failed to send reset email:', error)
        alert('Failed to send reset code. Please try again.')
      } finally {
        this.loading = false
      }
    },
    async resetPassword() {
      this.resetLoading = true
      try {
        await apiService.auth.resetPassword({
          email: this.email,
          captcha: this.captcha,
          newPassword: this.newPassword
        })
        alert('Password reset successful. Please return to login.')
        this.$router.push('/login')
      } catch (error) {
        console.error('Failed to reset password:', error)
        alert('Password reset failed. Please check the code and email.')
      } finally {
        this.resetLoading = false
      }
    },
    async resendEmail() {
      this.resendLoading = true
      try {
        // Simulate resending email
        await new Promise(resolve => setTimeout(resolve, 1000))
        alert('Reset code resent.')
      } catch (error) {
        console.error('Failed to resend email:', error)
        alert('Failed to resend. Please try again.')
      } finally {
        this.resendLoading = false
      }
    }
  }
}
</script>

<style scoped>
.forgot-password-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px 0;
}

.card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.btn-block {
  width: 100%;
}

.form-group {
  margin-bottom: 1rem;
}

.success-icon {
  margin-bottom: 20px;
}

.contact-info p {
  margin-bottom: 5px;
  font-size: 14px;
}

.contact-info i {
  margin-right: 10px;
  color: #3498DB;
}
</style> 